import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Icon } from '../Icon';
import { Title, Text, ContentWrapper, CloseWrapper, Container } from './styles';
import { x } from '@xstyled/styled-components';
import { toastTitleMap, toastIconMap, toastIconFill } from './constants';
var Toast = function (_a) {
    var closeToast = _a.closeToast, title = _a.title, text = _a.text, type = _a.type, autoClose = _a.autoClose;
    var icon = toastIconMap[type];
    var fill = toastIconFill[type];
    useEffect(function () {
        if (!autoClose)
            return;
        var timer = setTimeout(function () { return closeToast === null || closeToast === void 0 ? void 0 : closeToast(); }, autoClose);
        return function () { return clearTimeout(timer); };
    }, []);
    return (_jsxs(Container, { autoClose: autoClose, fill: fill, children: [_jsx(x.div, { mx: "12px", children: _jsx(Icon, { icon: icon, fill: fill, size: "20px" }) }), _jsxs(ContentWrapper, { children: [_jsxs("div", { children: [_jsx(Title, { children: title || toastTitleMap[type] }), text && _jsx(Text, { children: text })] }), _jsx(CloseWrapper, { children: _jsx("div", { onClick: closeToast, children: _jsx(Icon, { icon: "close" }) }) })] })] }));
};
export default Toast;
